import DashboardOutlinedIcon from "@mui/icons-material/DashboardOutlined";
import DescriptionOutlinedIcon from "@mui/icons-material/DescriptionOutlined";
import PersonSearchOutlinedIcon from "@mui/icons-material/PersonSearchOutlined";
import { Box, Container, AppBar as MuiAppBar, Stack, Toolbar, useTheme } from "@mui/material";
import { NewAnalysisButton } from "Components/_Shared/Buttons/NewAnalysisButton";
import { Spacing } from "Infrastructure/Themes/Themes";
import { Resources, useResource } from "Infrastructure/Translations/Resources";
import { AdminRouting, AppRouting, getAdminUrl } from "Infrastructure/Utils/UrlUtils";
import type { FC } from "react";
import { UnstyledLink } from "../Routing/UnstyledLink";
import { UserMenu } from "../UserMenu/UserMenu";
import { AppBarMenuItem, type AppBarMenuItemProps } from "./AppBarMenuItem";
import { TestEnv } from "./TestEnv";

type Props = {
  readonly variant?: "light" | "dark";
};

export const AppBar: FC<Props> = ({ variant = "light" }) => {
  const theme = useTheme();
  const { t } = useResource();
  const menuItems: AppBarMenuItemProps[] = [
    {
      name: t(Resources.Dashboard.Title),
      to: AppRouting.Dashboard.path(),
      icon: <DashboardOutlinedIcon color="secondary" />,
    },
    {
      name: t(Resources.AnalysesListing.Title),
      to: AppRouting.Analyses.path(),
      icon: <DescriptionOutlinedIcon color="secondary" />,
    },
    {
      name: t(Resources.Clients.Title),
      to: getAdminUrl(AdminRouting.ClientContracts.path()),
      target: "_blank",
      icon: <PersonSearchOutlinedIcon color="secondary" />,
    },
  ];

  return (
    <MuiAppBar
      position="static"
      elevation={0}
      sx={({ colors }) => ({ background: variant === "light" ? colors.white : colors.backgroundSecondary })}
    >
      <TestEnv />
      <Toolbar>
        <Container>
          <Stack direction="row" justifyContent="space-between" alignItems="center" width="100%">
            <Stack direction="row" justifyContent="space-between" alignItems="center">
              <UnstyledLink to="/">
                <Box
                  component="img"
                  sx={{
                    height: theme.spacing(8),
                    marginRight: theme.spacing(6),
                  }}
                  alt="Logo ZPF"
                  src="/images/zpf_logo_small.png"
                />
              </UnstyledLink>

              {menuItems.map((item) => (
                <AppBarMenuItem name={item.name} to={item.to} icon={item.icon} target={item.target} key={item.name} />
              ))}
            </Stack>
            <Stack direction={"row"} justifyContent="flex-end" alignItems="center" spacing={Spacing.L}>
              <NewAnalysisButton />
              <UserMenu />
            </Stack>
          </Stack>
        </Container>
      </Toolbar>
    </MuiAppBar>
  );
};
